import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
    SpsButtonComponent,
    SpsButtonGroupComponent,
    SpsCardComponent,
    SpsCardFooterComponent,
    SpsCardHeaderComponent,
    SpsCardTabbedPaneComponent,
    SpsGridColComponent,
    SpsGridRowComponent,
    SpsSpinnerComponent,
    SpsTabsComponent,
    SpsTagComponent,
} from "../components/index";
import {
    SpsGridWidthDirective,
    SpsIconDirective,
} from "../directives/index";

@NgModule({
    imports: [CommonModule],
    declarations: [
        SpsButtonComponent,
        SpsButtonGroupComponent,
        SpsCardComponent,
        SpsCardFooterComponent,
        SpsCardHeaderComponent,
        SpsCardTabbedPaneComponent,
        SpsGridColComponent,
        SpsGridRowComponent,
        SpsSpinnerComponent,
        SpsTabsComponent,
        SpsTagComponent,
        SpsGridWidthDirective,
        SpsIconDirective,
    ],
    exports: [
        SpsButtonComponent,
        SpsButtonGroupComponent,
        SpsCardComponent,
        SpsCardFooterComponent,
        SpsCardHeaderComponent,
        SpsCardTabbedPaneComponent,
        SpsGridColComponent,
        SpsGridRowComponent,
        SpsSpinnerComponent,
        SpsTabsComponent,
        SpsTagComponent,
        SpsGridWidthDirective,
        SpsIconDirective,
    ]
})
export class SpsDSCoreModule {}
